module.exports = __webpack_public_path__ + "static/img/left-bottom-row-5.a422fc8b.png";